import React, { Component, type ErrorInfo } from 'react';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class BlockPreviewBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(_error: unknown, _info: ErrorInfo) {
    // Boundary intentionally keeps UI safe; logging can be added later.
  }

  render() {
    if (this.state.hasError) {
      // role=alert pushes the failure message to the polite SR queue so users
      // hear it even though it just replaced the preview silently.
      return <div role="alert">This block failed to render — check content &amp; style</div>;
    }
    return this.props.children;
  }
}
